import { useState } from "react";
import { TrashIcon } from "@heroicons/react/20/solid";
import Select from "react-select";
import axios from "axios";
import zIndex from "@mui/material/styles/zIndex";

const customStyles = {
  control: (provided) => ({
    ...provided,
    zIndex: 0,
    backgroundColor: "#4B5563",
    borderColor: "#6B7280",
    color: "#E5E7EB",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#F97316",
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#4B5563",
    zIndex: 9999,
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#F97316" : "#4B5563",
    color: state.isSelected ? "#FFF" : "#E5E7EB",
    "&:hover": {
      backgroundColor: "#6B7280",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#E5E7EB",
  }),
  input: (provided) => ({
    ...provided,
    color: "#E5E7EB",
  }),
};

export default function TandMForm({
  isEditing,
  editingId,
  formData,
  setFormData,
  availableLabourItems,
  availableMaterialItems,
  selectedLabourItem,
  setSelectedLabourItem,
  selectedMaterialItem,
  setSelectedMaterialItem,
  labourQty,
  setLabourQty,
  generateTandMPDF,
  materialQty,
  setMaterialQty,
  images,
  setImages,
  selectedVendor,
  setSelectedVendor,
  selectedLabourBidArea,
  setSelectedLabourBidArea,
  selectedMaterialAnticipatedBidArea,
  setSelectedMaterialAnticipatedBidArea,
  selectedLabourCostCode,
  setSelectedLabourCostCode,
  selectedMaterialCostCode,
  setSelectedMaterialCostCode,
  bidAreaOptions,
  editingLabourItemIndex,
  setEditingLabourItemIndex,
  editingMaterialItemIndex,
  setEditingMaterialItemIndex,
  editLabourForm,
  setEditLabourForm,
  editMaterialForm,
  setEditMaterialForm,
  handleCreateToggle,
  companyProfile,
  preparedBy,
  setAlert,
  vendorOptions,
  costCodeOptions,
  subtotalCost,
  subtotalPrice,
  taxRate,
  taxAmount,
  totalPrice,
  project,
  setTimeAndMaterials,
  setProject,
  setIsCreating,
  setIsEditing,
  setEditingId,
  setViewMode,
  handleDeleteLabourItem,
  handleDeleteMaterialItem,
  handleDeleteSurchargeItem,
}) {
  const [surchargeTitle, setSurchargeTitle] = useState("");
  const [surchargeQty, setSurchargeQty] = useState("");
  const [surchargeUnitCost, setSurchargeUnitCost] = useState("");
  const [surchargeUnitRate, setSurchargeUnitRate] = useState("");
  const [selectedSurchargeCostCode, setSelectedSurchargeCostCode] =
    useState(null);
  const [selectedSurchargeBidArea, setSelectedSurchargeBidArea] =
    useState(null);
  const [editingSurchargeItemIndex, setEditingSurchargeItemIndex] =
    useState(null);
  const [editSurchargeForm, setEditSurchargeForm] = useState({
    title: "",
    quantityUsed: "",
    unitCost: "",
    unitRate: "",
    costCode: null,
    bidArea: null,
    customer: true,
    budget: true,
  });

  const handleMaterialItemChange = (selectedOption) => {
    setSelectedMaterialItem(selectedOption);
    if (selectedOption) {
      if (selectedOption.vendor) {
        const vendorOption = vendorOptions.find(
          (opt) => opt.value === selectedOption.vendor
        );
        setSelectedVendor(vendorOption || null);
      } else {
        setSelectedVendor(null);
      }
      if (selectedOption.costCode) {
        const costCodeOption = costCodeOptions.find(
          (opt) => opt.value === selectedOption.costCode
        );
        setSelectedMaterialCostCode(costCodeOption || null);
      } else {
        setSelectedMaterialCostCode(null);
      }
    } else {
      setSelectedVendor(null);
      setSelectedMaterialCostCode(null);
    }
  };

  const handleLabourItemChange = (selectedOption) => {
    setSelectedLabourItem(selectedOption);
    if (selectedOption && selectedOption.costCode) {
      const costCodeOption = costCodeOptions.find(
        (opt) => opt.value === selectedOption.costCode
      );
      setSelectedLabourCostCode(costCodeOption || null);
    } else {
      setSelectedLabourCostCode(null);
    }
  };

  const addLabourItem = () => {
    if (!selectedLabourItem || !labourQty || !selectedLabourCostCode) {
      setAlert({
        open: true,
        type: "error",
        title: "Missing Information",
        message: "Please select a labour item, quantity, and cost code.",
      });
      return;
    }

    console.log(selectedLabourItem);

    const costCodeOption = costCodeOptions.find(
      (opt) => opt.value === selectedLabourCostCode.value
    );

    const newLabourItem = {
      category: "L",
      sectionNumber: "TBD",
      costCodeDescription:
        selectedLabourItem.description ||
        selectedLabourItem.costCodeDescription ||
        costCodeOption?.label ||
        "Labor Cost Code",
      costCode: selectedLabourCostCode.value,
      amount: (parseFloat(labourQty) || 0) * (selectedLabourItem.unitRate || 0),
      contractLabourItem: selectedLabourItem.isContractItem
        ? selectedLabourItem.value
        : null,
      budgetLineItem: !selectedLabourItem.isContractItem
        ? {
            _id: selectedLabourItem.value,
            costCodeDescription:
              selectedLabourItem.label ||
              selectedLabourItem.description ||
              "Unnamed",
            unitRate: selectedLabourItem.unitRate || 0,
            cost: selectedLabourItem.unitCost || 0,
            uom: selectedLabourItem.uom || "N/A",
            costCode: selectedLabourItem.costCode || null,
            bidArea: selectedLabourBidArea ? selectedLabourBidArea.value : "",
            isContractItem: false,
          }
        : null,
      quantityUsed: parseFloat(labourQty) || 0,
      totalCost:
        (parseFloat(labourQty) || 0) * (selectedLabourItem.unitCost || 0),
      totalPrice:
        (parseFloat(labourQty) || 0) * (selectedLabourItem.unitRate || 0),
      bidArea: selectedLabourBidArea ? selectedLabourBidArea.value : "",
      unitRate: selectedLabourItem.unitRate || 0,
      unitCost: selectedLabourItem.unitCost || 0,
      uom: selectedLabourItem.uom || "N/A",
      customer: true,
      budget: true,
    };

    setFormData((prev) => ({
      ...prev,
      labourItems: [...prev.labourItems, newLabourItem],
    }));
    setSelectedLabourItem(null);
    setLabourQty("");
    setSelectedLabourBidArea(null);
    setSelectedLabourCostCode(null);
  };

  const addMaterialItem = () => {
    if (!selectedMaterialItem || !materialQty || !selectedMaterialCostCode) {
      setAlert({
        open: true,
        type: "error",
        title: "Missing Information",
        message: "Please select a material item, quantity, and cost code.",
      });
      return;
    }

    const costCodeOption = costCodeOptions.find(
      (opt) => opt.value === selectedMaterialCostCode.value
    );

    const newMaterialItem = {
      category: "M",
      sectionNumber: "TBD",
      costCodeDescription: costCodeOption?.label || "Material Cost Code",
      costCode: selectedMaterialCostCode.value,
      amount:
        (parseFloat(materialQty) || 0) * (selectedMaterialItem.price || 0),
      budgetLineItem: selectedMaterialItem.value,
      quantityUsed: parseFloat(materialQty) || 0,
      requiredQty: parseFloat(materialQty) || 0,
      totalCost:
        (parseFloat(materialQty) || 0) * (selectedMaterialItem.cost || 0),
      totalPrice:
        (parseFloat(materialQty) || 0) * (selectedMaterialItem.price || 0),
      price: parseFloat(selectedMaterialItem.price) || 0,
      cost: parseFloat(selectedMaterialItem.cost) || 0,
      size: selectedMaterialItem.size || "N/A",
      itemCode: selectedMaterialItem.itemCode || "N/A",
      itemDescription: selectedMaterialItem.itemDescription || "Unnamed",
      container: selectedMaterialItem.container || "N/A",
      vendor: selectedVendor ? selectedVendor.value : null,
      bidArea: selectedMaterialAnticipatedBidArea
        ? selectedMaterialAnticipatedBidArea.value
        : "",
      customer: true,
      budget: true,
    };

    setFormData((prev) => ({
      ...prev,
      materialItems: [...prev.materialItems, newMaterialItem],
    }));
    setSelectedMaterialItem(null);
    setMaterialQty("");
    setSelectedVendor(null);
    setSelectedMaterialAnticipatedBidArea(null);
    setSelectedMaterialCostCode(null);
  };

  const addSurchargeItem = () => {
    if (
      !surchargeTitle ||
      !surchargeQty ||
      !surchargeUnitCost ||
      !surchargeUnitRate ||
      !selectedSurchargeCostCode
    ) {
      setAlert({
        open: true,
        type: "error",
        title: "Missing Information",
        message:
          "Please provide title, quantity, unit cost, unit rate, and cost code for the surcharge item.",
      });
      return;
    }

    const costCodeOption = costCodeOptions.find(
      (opt) => opt.value === selectedSurchargeCostCode.value
    );

    const newSurchargeItem = {
      title: surchargeTitle,
      quantityUsed: parseFloat(surchargeQty) || 0,
      unitCost: parseFloat(surchargeUnitCost) || 0,
      unitRate: parseFloat(surchargeUnitRate) || 0,
      totalCost:
        (parseFloat(surchargeQty) || 0) * (parseFloat(surchargeUnitCost) || 0),
      totalPrice:
        (parseFloat(surchargeQty) || 0) * (parseFloat(surchargeUnitRate) || 0),
      uom: "N/A",
      costCode: selectedSurchargeCostCode.value,
      bidArea: selectedSurchargeBidArea ? selectedSurchargeBidArea.value : "",
      customer: true,
      budget: true,
    };

    setFormData((prev) => ({
      ...prev,
      surchargeItems: [...(prev.surchargeItems || []), newSurchargeItem],
    }));
    setSurchargeTitle("");
    setSurchargeQty("");
    setSurchargeUnitCost("");
    setSurchargeUnitRate("");
    setSelectedSurchargeCostCode(null);
    setSelectedSurchargeBidArea(null);
  };

  const handleEditLabourItem = (index) => {
    const item = formData.labourItems[index];
    const labourOption = availableLabourItems.find(
      (opt) =>
        opt.value ===
        (item.contractLabourItem ||
          item.budgetLineItem?._id ||
          item.budgetLineItem)
    ) || {
      value: item.budgetLineItem?._id || item.budgetLineItem,
      label:
        item.budgetLineItem?.costCodeDescription ||
        item.description ||
        "Unnamed",
      unitRate: item.budgetLineItem?.unitRate || item.unitRate || 0,
      unitCost: item.budgetLineItem?.cost || item.unitCost || 0,
      uom: item.budgetLineItem?.uom || item.uom || "N/A",
      costCode: item.budgetLineItem?.costCode || item.costCode || null,
      bidArea: item.budgetLineItem?.bidArea || item.bidArea || "",
      isContractItem: !!item.contractLabourItem,
      description:
        item.budgetLineItem?.costCodeDescription ||
        item.description ||
        "Unnamed",
    };
    const costCodeOption = costCodeOptions.find(
      (opt) => opt.value === item.costCode
    );
    const bidAreaOption = bidAreaOptions.find(
      (opt) => opt.value === item.bidArea
    );

    setEditLabourForm({
      contractLabourItem: labourOption,
      quantityUsed: item.quantityUsed.toString(),
      bidArea: bidAreaOption || null,
      costCode: costCodeOption || null,
      customer: item.customer ?? true,
      budget: item.budget ?? true,
    });
    setEditingLabourItemIndex(index);
  };

  const handleEditMaterialItem = (index) => {
    const item = formData.materialItems[index];
    const materialOption = availableMaterialItems.find(
      (opt) => opt.value === (item.budgetLineItem?._id || item.budgetLineItem)
    ) || {
      value: item.budgetLineItem?._id || item.budgetLineItem,
      label: item.itemDescription || "Unnamed",
      itemDescription: item.itemDescription || "Unnamed",
      itemCode: item.itemCode || "N/A",
      size: item.size || "N/A",
      container: item.container || "N/A",
      cost: item.cost || 0,
      price: item.price || 0,
      vendor: item.vendor || null,
      costCode: item.costCode || null,
      bidArea: item.bidArea || "",
    };
    const vendorOption = vendorOptions.find(
      (opt) => opt.value === (item.vendor?._id || item.vendor)
    );
    const costCodeOption = costCodeOptions.find(
      (opt) => opt.value === item.costCode
    );
    const bidAreaOption = bidAreaOptions.find(
      (opt) => opt.value === item.bidArea
    );

    setEditMaterialForm({
      budgetLineItem: materialOption,
      quantityUsed: item.quantityUsed.toString(),
      vendor: vendorOption || null,
      bidArea: bidAreaOption || null,
      costCode: costCodeOption || null,
      itemCode: item.itemCode || materialOption?.itemCode || "N/A",
      customer: item.customer ?? true,
      budget: item.budget ?? true,
    });
    setEditingMaterialItemIndex(index);
  };

  const handleEditSurchargeItem = (index) => {
    const item = formData.surchargeItems[index];
    const costCodeOption = costCodeOptions.find(
      (opt) => opt.value === item.costCode
    );
    const bidAreaOption = bidAreaOptions.find(
      (opt) => opt.value === item.bidArea
    );

    setEditSurchargeForm({
      title: item.title,
      quantityUsed: item.quantityUsed.toString(),
      unitCost: item.unitCost.toString(),
      unitRate: item.unitRate.toString(),
      costCode: costCodeOption || null,
      bidArea: bidAreaOption || null,
      customer: item.customer ?? true,
      budget: item.budget ?? true,
    });
    setEditingSurchargeItemIndex(index);
  };

  const updateLabourItem = () => {
    if (
      !editLabourForm.contractLabourItem ||
      !editLabourForm.quantityUsed ||
      !editLabourForm.costCode
    ) {
      setAlert({
        open: true,
        type: "error",
        title: "Missing Information",
        message: "Please select a labour item, quantity, and cost code.",
      });
      return;
    }

    const costCodeOption = costCodeOptions.find(
      (opt) => opt.value === editLabourForm.costCode.value
    );

    const updatedItem = {
      category: "L",
      sectionNumber: "TBD",
      costCodeDescription:
        editLabourForm.contractLabourItem.description ||
        editLabourForm.contractLabourItem.costCodeDescription ||
        costCodeOption?.label ||
        "Labor Cost Code",
      costCode: editLabourForm.costCode.value,
      amount:
        (parseFloat(editLabourForm.quantityUsed) || 0) *
        (editLabourForm.contractLabourItem.unitRate || 0),
      contractLabourItem: editLabourForm.contractLabourItem.isContractItem
        ? editLabourForm.contractLabourItem.value
        : null,
      budgetLineItem: !editLabourForm.contractLabourItem.isContractItem
        ? {
            _id: editLabourForm.contractLabourItem.value,
            costCodeDescription:
              editLabourForm.contractLabourItem.description ||
              editLabourForm.contractLabourItem.costCodeDescription ||
              "Unnamed",
            unitRate: editLabourForm.contractLabourItem.unitRate || 0,
            cost: editLabourForm.contractLabourItem.unitCost || 0,
            uom: editLabourForm.contractLabourItem.uom || "N/A",
            costCode: editLabourForm.contractLabourItem.costCode || null,
            bidArea: editLabourForm.bidArea ? editLabourForm.bidArea.value : "",
            isContractItem: false,
          }
        : null,
      quantityUsed: parseFloat(editLabourForm.quantityUsed) || 0,
      totalCost:
        (parseFloat(editLabourForm.quantityUsed) || 0) *
        (editLabourForm.contractLabourItem.unitCost || 0),
      totalPrice:
        (parseFloat(editLabourForm.quantityUsed) || 0) *
        (editLabourForm.contractLabourItem.unitRate || 0),
      bidArea: editLabourForm.bidArea ? editLabourForm.bidArea.value : "",
      unitRate: editLabourForm.contractLabourItem.unitRate || 0,
      unitCost: editLabourForm.contractLabourItem.unitCost || 0,
      uom: editLabourForm.contractLabourItem.uom || "N/A",
      customer: editLabourForm.customer,
      budget: editLabourForm.budget,
    };

    setFormData((prev) => ({
      ...prev,
      labourItems: prev.labourItems.map((item, idx) =>
        idx === editingLabourItemIndex ? updatedItem : item
      ),
    }));
    setEditingLabourItemIndex(null);
    setEditLabourForm({
      contractLabourItem: null,
      quantityUsed: "",
      bidArea: null,
      costCode: null,
      customer: true,
      budget: true,
    });
  };

  const updateMaterialItem = () => {
    if (
      !editMaterialForm.budgetLineItem ||
      !editMaterialForm.quantityUsed ||
      !editMaterialForm.costCode
    ) {
      setAlert({
        open: true,
        type: "error",
        title: "Missing Information",
        message: "Please select a material item, quantity, and cost code.",
      });
      return;
    }

    const costCodeOption = costCodeOptions.find(
      (opt) => opt.value === editMaterialForm.costCode.value
    );

    const updatedItem = {
      category: "M",
      sectionNumber: "TBD",
      costCodeDescription: costCodeOption?.label || "Material Cost Code",
      costCode: editMaterialForm.costCode.value,
      amount:
        (parseFloat(editMaterialForm.quantityUsed) || 0) *
        (editMaterialForm.budgetLineItem.price || 0),
      budgetLineItem: {
        _id: editMaterialForm.budgetLineItem.value,
        itemDescription:
          editMaterialForm.budgetLineItem.itemDescription || "Unnamed",
        itemCode: editMaterialForm.budgetLineItem.itemCode || "N/A",
        size: editMaterialForm.budgetLineItem.size || "N/A",
        container: editMaterialForm.budgetLineItem.container || "N/A",
        cost: editMaterialForm.budgetLineItem.cost || 0,
        price: editMaterialForm.budgetLineItem.price || 0,
        vendor: editMaterialForm.budgetLineItem.vendor || null,
        costCode: editMaterialForm.budgetLineItem.costCode || null,
        bidArea: editMaterialForm.bidArea ? editMaterialForm.bidArea.value : "",
      },
      quantityUsed: parseFloat(editMaterialForm.quantityUsed) || 0,
      requiredQty: parseFloat(editMaterialForm.quantityUsed) || 0,
      totalCost:
        (parseFloat(editMaterialForm.quantityUsed) || 0) *
        (editMaterialForm.budgetLineItem.cost || 0),
      totalPrice:
        (parseFloat(editMaterialForm.quantityUsed) || 0) *
        (editMaterialForm.budgetLineItem.price || 0),
      price: parseFloat(editMaterialForm.budgetLineItem.price) || 0,
      cost: parseFloat(editMaterialForm.budgetLineItem.cost) || 0,
      size: editMaterialForm.budgetLineItem.size || "N/A",
      itemCode: editMaterialForm.budgetLineItem.itemCode || "N/A",
      itemDescription:
        editMaterialForm.budgetLineItem.itemDescription || "Unnamed",
      container: editMaterialForm.budgetLineItem.container || "N/A",
      vendor: editMaterialForm.vendor ? editMaterialForm.vendor.value : null,
      bidArea: editMaterialForm.bidArea ? editMaterialForm.bidArea.value : "",
      customer: editMaterialForm.customer,
      budget: editMaterialForm.budget,
    };

    setFormData((prev) => ({
      ...prev,
      materialItems: prev.materialItems.map((item, idx) =>
        idx === editingMaterialItemIndex ? updatedItem : item
      ),
    }));
    setEditingMaterialItemIndex(null);
    setEditMaterialForm({
      budgetLineItem: null,
      quantityUsed: "",
      vendor: null,
      bidArea: null,
      costCode: null,
      customer: true,
      budget: true,
    });
  };

  const updateSurchargeItem = () => {
    if (
      !editSurchargeForm.title ||
      !editSurchargeForm.quantityUsed ||
      !editSurchargeForm.unitCost ||
      !editSurchargeForm.unitRate ||
      !editSurchargeForm.costCode
    ) {
      setAlert({
        open: true,
        type: "error",
        title: "Missing Information",
        message:
          "Please provide title, quantity, unit cost, unit rate, and cost code for the surcharge item.",
      });
      return;
    }

    const costCodeOption = costCodeOptions.find(
      (opt) => opt.value === editSurchargeForm.costCode.value
    );

    const updatedItem = {
      title: editSurchargeForm.title,
      quantityUsed: parseFloat(editSurchargeForm.quantityUsed) || 0,
      unitCost: parseFloat(editSurchargeForm.unitCost) || 0,
      unitRate: parseFloat(editSurchargeForm.unitRate) || 0,
      totalCost:
        (parseFloat(editSurchargeForm.quantityUsed) || 0) *
        (parseFloat(editSurchargeForm.unitCost) || 0),
      totalPrice:
        (parseFloat(editSurchargeForm.quantityUsed) || 0) *
        (parseFloat(editSurchargeForm.unitRate) || 0),
      uom: "N/A",
      costCode: editSurchargeForm.costCode.value,
      bidArea: editSurchargeForm.bidArea ? editSurchargeForm.bidArea.value : "",
      customer: editSurchargeForm.customer,
      budget: editSurchargeForm.budget,
    };

    setFormData((prev) => ({
      ...prev,
      surchargeItems: prev.surchargeItems.map((item, idx) =>
        idx === editingSurchargeItemIndex ? updatedItem : item
      ),
    }));
    setEditingSurchargeItemIndex(null);
    setEditSurchargeForm({
      title: "",
      quantityUsed: "",
      unitCost: "",
      unitRate: "",
      costCode: null,
      bidArea: null,
      customer: true,
      budget: true,
    });
  };

  const cancelEditLabourItem = () => {
    setEditingLabourItemIndex(null);
    setEditLabourForm({
      contractLabourItem: null,
      quantityUsed: "",
      bidArea: null,
      costCode: null,
      customer: true,
      budget: true,
    });
  };

  const cancelEditMaterialItem = () => {
    setEditingMaterialItemIndex(null);
    setEditMaterialForm({
      budgetLineItem: null,
      quantityUsed: "",
      vendor: null,
      bidArea: null,
      costCode: null,
      customer: true,
      budget: true,
    });
  };

  const cancelEditSurchargeItem = () => {
    setEditingSurchargeItemIndex(null);
    setEditSurchargeForm({
      title: "",
      quantityUsed: "",
      unitCost: "",
      unitRate: "",
      costCode: null,
      bidArea: null,
      customer: true,
      budget: true,
    });
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages((prev) => [...prev, ...files]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.labourItems.length === 0 &&
      formData.materialItems.length === 0 &&
      (!formData.surchargeItems || formData.surchargeItems.length === 0)
    ) {
      setAlert({
        open: true,
        type: "error",
        title: "No Items Added",
        message: "Please add at least one labour, material, or surcharge item.",
      });
      return;
    }
    if (!formData.signedBy.trim()) {
      setAlert({
        open: true,
        type: "error",
        title: "Missing Information",
        message: "Please provide an 'Approved by' name.",
      });
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("labourItems", JSON.stringify(formData.labourItems));
    formDataToSend.append(
      "materialItems",
      JSON.stringify(formData.materialItems)
    );
    formDataToSend.append(
      "surchargeItems",
      JSON.stringify(formData.surchargeItems || [])
    );
    formDataToSend.append("scopeOfWork", formData.scopeOfWork);
    formDataToSend.append("signedBy", formData.signedBy);
    formDataToSend.append("overheadPercentage", formData.overheadPercentage);

    if (!isEditing && formData.signature instanceof File) {
      formDataToSend.append("signature", formData.signature);
    }

    images.forEach((image) => {
      if (image instanceof File) {
        formDataToSend.append("images", image);
      }
    });

    try {
      const token = localStorage.getItem("token");
      let response;

      if (isEditing) {
        response = await axios.put(
          `https://erp-production-72da01c8e651.herokuapp.com/api/time-and-material/${project._id}/${editingId}`,
          formDataToSend,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        setTimeAndMaterials((prev) =>
          prev.map((item) => (item._id === editingId ? response.data : item))
        );
      } else {
        response = await axios.post(
          `https://erp-production-72da01c8e651.herokuapp.com/api/time-and-material/signed/${project._id}`,
          formDataToSend,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        setTimeAndMaterials((prev) => [...prev, response.data]);
        setProject((prev) => ({
          ...prev,
          timeAndMaterials: [...prev.timeAndMaterials, response.data._id],
        }));
      }

      setIsCreating(false);
      setIsEditing(false);
      setEditingId(null);
      setViewMode("list");
      setFormData({
        labourItems: [],
        materialItems: [],
        surchargeItems: [],
        scopeOfWork: "",
        signature: null,
        signedBy: "",
        overheadPercentage: companyProfile?.defaultOverhead || 0,
      });
      setImages([]);
      setEditingLabourItemIndex(null);
      setEditingMaterialItemIndex(null);
      setEditingSurchargeItemIndex(null);
      setAlert({
        open: true,
        type: "success",
        title: "Success",
        message: `Entry ${isEditing ? "updated" : "saved"} successfully!`,
      });
    } catch (err) {
      setAlert({
        open: true,
        type: "error",
        title: "Error",
        message: `Failed to ${isEditing ? "update" : "save"} entry.`,
      });
      console.error("Error:", err);
    }
  };

  return (
    <div className="bg-gray-700 p-6 rounded-lg border border-gray-600">
      <div className="flex justify-between items-center mx-auto">
        <h3 className="text-lg font-semibold text-white mb-4">
          {isEditing ? "Edit Entry" : "New Entry"}
        </h3>
        {isEditing ? (
          <button
            onClick={() => generateTandMPDF(formData)}
            className="px-4 py-2 text-sm font-medium text-gray-200 bg-orange-400 rounded-md hover:bg-orange-500 transition-colors duration-200 shadow-sm"
          >
            Download PDF
          </button>
        ) : (
          ""
        )}
      </div>

      <form onSubmit={handleSubmit}>
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-200 mb-2">
              Overhead Percentage
            </label>
            <input
              type="number"
              min="0"
              step="1"
              value={formData.overheadPercentage}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  overheadPercentage: parseFloat(e.target.value) || 0,
                }))
              }
              className="w-24 p-2 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
              placeholder="%"
            />
            <span className="ml-2 text-gray-200">%</span>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-200 mb-2">
              Labour Items
            </label>
            <div className="flex items-center space-x-4 ">
              <Select
                options={availableLabourItems}
                value={selectedLabourItem}
                onChange={handleLabourItemChange}
                placeholder="Select Labour Item"
                className="flex-1"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
              <input
                type="number"
                min="0"
                value={labourQty}
                onChange={(e) => setLabourQty(e.target.value)}
                className="w-24 p-2 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
                placeholder="Qty"
              />
              <Select
                options={costCodeOptions}
                value={selectedLabourCostCode}
                onChange={setSelectedLabourCostCode}
                placeholder="Select Cost Code"
                className="w-48"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
              <Select
                options={bidAreaOptions}
                value={selectedLabourBidArea}
                onChange={setSelectedLabourBidArea}
                placeholder="Select Bid Area"
                className="w-48"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
              <button
                type="button"
                onClick={addLabourItem}
                className="px-4 py-2 text-sm font-medium text-gray-200 bg-orange-400 rounded-md hover:bg-orange-500 transition-colors duration-200 shadow-sm"
              >
                Add
              </button>
            </div>
            {formData.labourItems.length > 0 && (
              <div className="overflow-x-auto mt-4">
                <table className="min-w-full divide-y divide-gray-600 bg-gray-700">
                  <thead className="bg-gray-800">
                    <tr>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Customer
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Budget
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Item
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Cost Code
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Qty
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Cost
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Price
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Bid Area
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        UOM
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-600">
                    {formData.labourItems.map((item, index) => (
                      <tr
                        key={index}
                        className="hover:bg-gray-500 transition-colors duration-200"
                      >
                        {editingLabourItemIndex === index ? (
                          <>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <input
                                type="checkbox"
                                checked={editLabourForm.customer}
                                onChange={(e) =>
                                  setEditLabourForm((prev) => ({
                                    ...prev,
                                    customer: e.target.checked,
                                  }))
                                }
                                className="h-4 w-4 text-orange-400 focus:ring-orange-500 border-gray-500 rounded"
                              />
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <input
                                type="checkbox"
                                checked={editLabourForm.budget}
                                onChange={(e) =>
                                  setEditLabourForm((prev) => ({
                                    ...prev,
                                    budget: e.target.checked,
                                  }))
                                }
                                className="h-4 w-4 text-orange-400 focus:ring-orange-500 border-gray-500 rounded"
                              />
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <Select
                                options={availableLabourItems}
                                value={editLabourForm.contractLabourItem}
                                onChange={(option) =>
                                  setEditLabourForm((prev) => ({
                                    ...prev,
                                    contractLabourItem: option,
                                    costCode: option?.costCode
                                      ? costCodeOptions.find(
                                          (opt) => opt.value === option.costCode
                                        )
                                      : prev.costCode,
                                  }))
                                }
                                placeholder="Select Labour Item"
                                styles={customStyles}
                                menuPortalTarget={document.body}
                              />
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <Select
                                options={costCodeOptions}
                                value={editLabourForm.costCode}
                                onChange={(option) =>
                                  setEditLabourForm((prev) => ({
                                    ...prev,
                                    costCode: option,
                                  }))
                                }
                                placeholder="Select Cost Code"
                                styles={customStyles}
                                menuPortalTarget={document.body}
                              />
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <input
                                type="number"
                                min="0"
                                value={editLabourForm.quantityUsed}
                                onChange={(e) =>
                                  setEditLabourForm((prev) => ({
                                    ...prev,
                                    quantityUsed: e.target.value,
                                  }))
                                }
                                className="w-24 p-2 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
                              />
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              $
                              {editLabourForm.contractLabourItem &&
                              editLabourForm.quantityUsed
                                ? (
                                    parseFloat(editLabourForm.quantityUsed) *
                                    editLabourForm.contractLabourItem.unitCost
                                  ).toFixed(2)
                                : "0.00"}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              $
                              {editLabourForm.contractLabourItem &&
                              editLabourForm.quantityUsed
                                ? (
                                    parseFloat(editLabourForm.quantityUsed) *
                                    editLabourForm.contractLabourItem.unitRate
                                  ).toFixed(2)
                                : "0.00"}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <Select
                                options={bidAreaOptions}
                                value={editLabourForm.bidArea}
                                onChange={(option) =>
                                  setEditLabourForm((prev) => ({
                                    ...prev,
                                    bidArea: option,
                                  }))
                                }
                                placeholder="Select Bid Area"
                                styles={customStyles}
                                menuPortalTarget={document.body}
                                className="min-w-48"
                              />
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              {editLabourForm.contractLabourItem?.uom || "N/A"}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <button
                                type="button"
                                onClick={updateLabourItem}
                                className="px-2 py-1 mb-1 -2text-sm font-medium text-gray-200 bg-orange-400 rounded hover:bg-orange-500 transition-colors duration-200 mr-2"
                              >
                                Save
                              </button>
                              <button
                                type="button"
                                onClick={cancelEditLabourItem}
                                className="px-2 py-1 text-sm font-medium text-gray-200 bg-gray-600 rounded hover:bg-gray-500 transition-colors duration-200 mr-2"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                onClick={() => handleDeleteLabourItem(index)}
                                className="text-red-400 hover:text-red-300 transition-colors duration-200"
                                disabled={
                                  formData.status === "Approved" ||
                                  formData.status === "Rejected"
                                }
                              >
                                <TrashIcon className="h-5 w-5" />
                              </button>
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <input
                                type="checkbox"
                                checked={item.customer}
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    labourItems: prev.labourItems.map(
                                      (li, idx) =>
                                        idx === index
                                          ? {
                                              ...li,
                                              customer: e.target.checked,
                                            }
                                          : li
                                    ),
                                  }))
                                }
                                className="h-4 w-4 text-orange-400 focus:ring-orange-500 border-gray-500 rounded"
                              />
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <input
                                type="checkbox"
                                checked={item.budget}
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    labourItems: prev.labourItems.map(
                                      (li, idx) =>
                                        idx === index
                                          ? { ...li, budget: e.target.checked }
                                          : li
                                    ),
                                  }))
                                }
                                className="h-4 w-4 text-orange-400 focus:ring-orange-500 border-gray-500 rounded"
                              />
                            </td>

                            <td className="px-4 py-3 text-sm text-gray-200">
                              {item.budgetLineItem?.label ||
                                item.contractLabourItem?.labourItem?.title ||
                                availableLabourItems
                                  .find(
                                    (opt) =>
                                      opt.value ===
                                      (item.contractLabourItem ||
                                        item.budgetLineItem?._id ||
                                        item.budgetLineItem)
                                  )
                                  ?.label.split(" (")[0] ||
                                "Unnamed"}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              {costCodeOptions.find(
                                (opt) => opt.value === item.costCode
                              )?.label || "Unassigned"}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              {item.quantityUsed}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              ${item.totalCost.toFixed(2)}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              ${item.totalPrice.toFixed(2)}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              {item.bidArea || "Unassigned"}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              {item.uom || "N/A"}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-200">
                              <button
                                type="button"
                                onClick={() => handleEditLabourItem(index)}
                                className="px-2 py-1 text-sm font-medium text-gray-200 bg-orange-400 rounded hover:bg-orange-500 transition-colors duration-200"
                              >
                                Edit
                              </button>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-200 mb-2">
              Material Items
            </label>
            <div className="flex items-center space-x-4">
              <Select
                options={availableMaterialItems}
                value={selectedMaterialItem}
                onChange={handleMaterialItemChange}
                placeholder="Select Material Item"
                className="flex-1"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
              <input
                type="number"
                value={materialQty}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number.isInteger(parseFloat(value))) {
                    setMaterialQty(value);
                  }
                }}
                className="w-24 p-2 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
                placeholder="Qty"
              />
              <Select
                options={costCodeOptions}
                value={selectedMaterialCostCode}
                onChange={setSelectedMaterialCostCode}
                placeholder="Select Cost Code"
                className="w-48"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
              <Select
                options={vendorOptions}
                value={selectedVendor}
                onChange={setSelectedVendor}
                placeholder="Select Vendor"
                className="w-48"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
              <Select
                options={bidAreaOptions}
                value={selectedMaterialAnticipatedBidArea}
                onChange={setSelectedMaterialAnticipatedBidArea}
                placeholder="Select Bid Area"
                className="w-48"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
              <button
                type="button"
                onClick={addMaterialItem}
                className="px-4 py-2 text-sm font-medium text-gray-200 bg-orange-400 rounded-md hover:bg-orange-500 transition-colors duration-200 shadow-sm"
              >
                Add
              </button>
            </div>
            {formData.materialItems.length > 0 && (
              <div className="overflow-x-auto mt-4">
                <table className="min-w-full divide-y divide-gray-600 bg-gray-700">
                  <thead className="bg-gray-800">
                    <tr>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Customer
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Budget
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Item
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Cost Code
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Size
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Container
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Qty
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Cost Per
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Price Per
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Vendor
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Bid Area
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-600">
                    {formData.materialItems.map((item, index) => {
                      const materialOption = availableMaterialItems.find(
                        (opt) =>
                          opt.value ===
                          (item.budgetLineItem?._id || item.budgetLineItem)
                      );
                      return (
                        <tr
                          key={index}
                          className="hover:bg-gray-500 transition-colors duration-200"
                        >
                          <td className="px-4 py-3 text-sm text-gray-200">
                            <input
                              type="checkbox"
                              checked={item.customer}
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  materialItems: prev.materialItems.map(
                                    (mi, idx) =>
                                      idx === index
                                        ? { ...mi, customer: e.target.checked }
                                        : mi
                                  ),
                                }))
                              }
                              className="h-4 w-4 text-orange-400 focus:ring-orange-500 border-gray-500 rounded"
                            />
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            <input
                              type="checkbox"
                              checked={item.budget}
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  materialItems: prev.materialItems.map(
                                    (mi, idx) =>
                                      idx === index
                                        ? { ...mi, budget: e.target.checked }
                                        : mi
                                  ),
                                }))
                              }
                              className="h-4 w-4 text-orange-400 focus:ring-orange-500 border-gray-500 rounded"
                            />
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            {item.budgetLineItem?.itemDescription ||
                              item.itemDescription ||
                              materialOption?.itemDescription ||
                              "Unnamed"}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            {costCodeOptions.find(
                              (opt) => opt.value === item.costCode
                            )?.label || "Unassigned"}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200 min-w-32">
                            {item.budgetLineItem?.size ||
                              item.size ||
                              materialOption?.size ||
                              "N/A"}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            {item.budgetLineItem?.container ||
                              item.container ||
                              materialOption?.container ||
                              "N/A"}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            {item.quantityUsed}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            ${item.budgetLineItem?.cost || item.cost.toFixed(2)}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            $
                            {item.quantityUsed > 0
                              ? (
                                  item.budgetLineItem?.price ||
                                  item.totalPrice / item.quantityUsed
                                ).toFixed(2)
                              : "0.00"}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            {item.vendor &&
                            typeof item.vendor === "object" &&
                            item.vendor.companyName
                              ? item.vendor.companyName
                              : vendorOptions.find(
                                  (opt) =>
                                    opt.value ===
                                    (item.budgetLineItem?.vendor ||
                                      item.vendor?._id ||
                                      item.vendor)
                                )?.label || "Unassigned"}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            {item.bidArea || "Unassigned"}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-200">
                            <button
                              type="button"
                              onClick={() => handleDeleteMaterialItem(index)}
                              className="text-red-400 hover:text-red-300 transition-colors duration-200"
                              disabled={
                                formData.status === "Approved" ||
                                formData.status === "Rejected"
                              }
                            >
                              <TrashIcon className="h-5 w-5" />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-200 mb-2">
              Surcharge Items
            </label>
            <div className="flex items-center space-x-4">
              <input
                type="text"
                value={surchargeTitle}
                onChange={(e) => setSurchargeTitle(e.target.value)}
                className="w-48 p-2 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
                placeholder="Surcharge Title"
              />
              <input
                type="number"
                min="0"
                value={surchargeQty}
                onChange={(e) => setSurchargeQty(e.target.value)}
                className="w-24 p-2 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
                placeholder="Qty"
              />
              <input
                type="number"
                min="0"
                step="0.01"
                value={surchargeUnitCost}
                onChange={(e) => setSurchargeUnitCost(e.target.value)}
                className="w-24 p-2 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
                placeholder="Unit Cost"
              />
              <input
                type="number"
                min="0"
                step="0.01"
                value={surchargeUnitRate}
                onChange={(e) => setSurchargeUnitRate(e.target.value)}
                className="w-24 p-2 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
                placeholder="Unit Rate"
              />
              <Select
                options={costCodeOptions}
                value={selectedSurchargeCostCode}
                onChange={setSelectedSurchargeCostCode}
                placeholder="Select Cost Code"
                className="w-48"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
              <Select
                options={bidAreaOptions}
                value={selectedSurchargeBidArea}
                onChange={setSelectedSurchargeBidArea}
                placeholder="Select Bid Area"
                className="w-48"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
              <button
                type="button"
                onClick={addSurchargeItem}
                className="px-4 py-2 text-sm font-medium text-gray-200 bg-orange-400 rounded-md hover:bg-orange-500 transition-colors duration-200 shadow-sm"
              >
                Add
              </button>
            </div>
            {formData.surchargeItems && formData.surchargeItems.length > 0 && (
              <div className="overflow-x-auto mt-4">
                <table className="min-w-full divide-y divide-gray-600 bg-gray-700">
                  <thead className="bg-gray-800">
                    <tr>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Customer
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Budget
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Title
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Cost Code
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Qty
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Unit Cost
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Unit Rate
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Total Cost
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Total Price
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Bid Area
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-600">
                    {formData.surchargeItems.map((item, index) => (
                      <tr
                        key={index}
                        className="hover:bg-gray-500 transition-colors duration-200"
                      >
                        <td className="px-4 py-3 text-sm text-gray-200">
                          <input
                            type="checkbox"
                            checked={item.customer}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                surchargeItems: prev.surchargeItems.map(
                                  (si, idx) =>
                                    idx === index
                                      ? { ...si, customer: e.target.checked }
                                      : si
                                ),
                              }))
                            }
                            className="h-4 w-4 text-orange-400 focus:ring-orange-500 border-gray-500 rounded"
                          />
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          <input
                            type="checkbox"
                            checked={item.budget}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                surchargeItems: prev.surchargeItems.map(
                                  (si, idx) =>
                                    idx === index
                                      ? { ...si, budget: e.target.checked }
                                      : si
                                ),
                              }))
                            }
                            className="h-4 w-4 text-orange-400 focus:ring-orange-500 border-gray-500 rounded"
                          />
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          {item.title}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          {costCodeOptions.find(
                            (opt) => opt.value === item.costCode
                          )?.label || "Unassigned"}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          {item.quantityUsed}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          ${item.unitCost.toFixed(2)}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          ${item.unitRate.toFixed(2)}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          ${item.totalCost.toFixed(2)}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          ${item.totalPrice.toFixed(2)}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          {item.bidArea || "Unassigned"}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-200">
                          <button
                            type="button"
                            onClick={() => handleEditSurchargeItem(index)}
                            className="px-2 py-1 text-sm font-medium text-gray-200 bg-orange-400 rounded hover:bg-orange-500 transition-colors duration-200 mr-2"
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            onClick={() => handleDeleteSurchargeItem(index)}
                            className="text-red-400 hover:text-red-300 transition-colors duration-200"
                            disabled={
                              formData.status === "Approved" ||
                              formData.status === "Rejected"
                            }
                          >
                            <TrashIcon className="h-5 w-5" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="mt-4 flex justify-end space-x-4">
              <div className="text-sm font-medium text-gray-200">
                Subtotal Cost:{" "}
                <span className="font-bold">${subtotalCost.toFixed(2)}</span>
              </div>
              <div className="text-sm font-medium text-gray-200">
                Subtotal Price (w/o OH):{" "}
                <span className="font-bold">${subtotalPrice.toFixed(2)}</span>
              </div>
              <div className="text-sm font-medium text-gray-200">
                Tax ({taxRate}%):{" "}
                <span className="font-bold">${taxAmount.toFixed(2)}</span>
              </div>
              <div className="text-sm font-medium text-gray-200">
                Total Price:{" "}
                <span className="font-bold">${totalPrice.toFixed(2)}</span>
              </div>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-200 mb-2">
              Scope of Work
            </label>
            <textarea
              value={formData.scopeOfWork}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  scopeOfWork: e.target.value,
                }))
              }
              className="w-full p-3 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
              rows="4"
              placeholder="Describe the work completed..."
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-200 mb-2">
              Upload Images
            </label>
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={handleImageUpload}
              className="block w-full text-sm text-gray-200 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-gray-600 file:text-gray-200 hover:file:bg-gray-500"
            />
            {images.length > 0 && (
              <div className="mt-4 grid grid-cols-3 gap-4">
                {images.map((image, index) => (
                  <img
                    key={index}
                    src={
                      typeof image === "string"
                        ? image
                        : URL.createObjectURL(image)
                    }
                    alt={`Preview ${index}`}
                    className="w-full h-24 object-cover rounded-lg border border-gray-600"
                  />
                ))}
              </div>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-200 mb-2">
              Signature
            </label>
            {isEditing && formData.signature ? (
              <img
                src={formData.signature}
                alt="Signature"
                className="w-[100px] h-[150px] object-contain rounded-lg border border-gray-600"
              />
            ) : (
              <input
                type="file"
                accept="image/*"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    signature: e.target.files[0],
                  }))
                }
                className="block w-full text-sm text-gray-200 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-gray-600 file:text-gray-200 hover:file:bg-gray-500"
              />
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-200 mb-2">
              Approved By
            </label>
            <input
              type="text"
              value={formData.signedBy}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  signedBy: e.target.value,
                }))
              }
              className="w-full p-3 rounded-md bg-gray-600 border-gray-500 text-gray-200 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
              placeholder="Enter name"
            />
          </div>
          <div className="flex justify-between">
            <button
              type="button"
              onClick={handleCreateToggle}
              className="px-4 py-2 text-sm font-medium text-gray-200 bg-gray-600 rounded-md hover:bg-gray-500 transition-colors duration-200 shadow-sm"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-3 text-sm font-medium text-gray-200 bg-orange-400 rounded-md hover:bg-orange-500 transition-colors duration-200 shadow-sm"
            >
              {isEditing ? "Update Entry" : "Save Entry"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
